import CGV from "../Exams/Register/Acknowledgment/CGV";

const CGVPage = () => {
  return (
    <div className="flex p-8 px-28 flex-col flex-start gap-8 self-stretch w-full h-full overflow-y-auto">
      <h1 className="text-2xl font-semibold">
        Conditions Générales de Vente (CGV)
      </h1>
      <div className="flex flex-col gap-4 text-sm text-gray-700 leading-relaxed">
        <CGV />
      </div>
    </div>
  );
};

export default CGVPage;
